'use client';

import { useEffect } from 'react';
import posthog from 'posthog-js';
import { useSession } from '@impact/auth/client';

interface SessionWithUser {
  user?: { id?: string; email?: string; name?: string };
}

export function PostHogIdentify() {
  const { session } = useSession<SessionWithUser>();
  const userId = session?.user?.id;

  useEffect(() => {
    if (userId) {
      posthog.identify(userId, {
        email: session?.user?.email,
        name: session?.user?.name,
      });
    } else {
      posthog.reset();
    }
  }, [userId, session?.user?.email, session?.user?.name]);

  return null;
}
